let addBirthdayToggle = document.querySelector('.customer__birthday-add-toggle');
let addBirthdayCloseHeader = document.querySelector('.customer__birthday-add-header');
let addBirthdayCloseButton = addBirthdayCloseHeader?.querySelector('.customer__birthday-add-close');
let addBirthdayForm = document.querySelector('.customer__birthday-add-form');

addBirthdayToggle?.addEventListener('click', function(){
    addBirthdayToggle.classList.toggle('d-none');
    addBirthdayCloseHeader.classList.toggle('d-none');
    addBirthdayForm.classList.toggle('d-none');
});

addBirthdayCloseButton?.addEventListener('click', function(){
    addBirthdayCloseHeader.classList.toggle('d-none');
    addBirthdayToggle.classList.toggle('d-none');
    addBirthdayForm.classList.toggle('d-none');
});

const submitBirthday = async (button) => {
    const birthdayElement = button.parentElement.parentElement;
    const spinner = birthdayElement.querySelector("[data-spinner]");
    button.disabled = true;
  
    const birthdayDateObject = new Date(birthdayElement.querySelector('input[type="date"]').value)
    const currentDate = new Date()
  
    if (birthdayDateObject > currentDate) {
      alert(window.theme.strings.birthday_future_select_error)
      
      button.disabled = false;
  
      return
    }
  
    const birthdayObject = JSON.parse(
      birthdayElement.querySelector("[birthday-data]").innerHTML
    );
    const dateUnix = Math.floor(
      birthdayDateObject.getTime() / 1000
    );
  
    const newBirthday = {
      customer: window.customer.id,
      email: window.customer.email,
      properties: birthdayObject,
    };
    newBirthday.properties.date = dateUnix;
  
    const response = await fetch(
      `https://konges-sloejd-middleman.vercel.app/api/update-property-fields/${theme.customer_club.store}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(newBirthday),
      }
    ).then((r) => r.json());
  
    button.disabled = false;
  
    birthdayElement.querySelector("[birthday-data]").innerHTML = JSON.stringify({
      ...birthdayObject,
      current_tag: response.current_tag,
    });
  };
  
  const currentBirthdayList = document.querySelector("[data-birthday-list]");
  const newBirthdayForm = document.querySelector("[data-new-birthday-form]");
  const newBirthdayButton = document.querySelector("[data-new-birthday]");
  let existingBirthdayInputs = currentBirthdayList?.querySelectorAll('.customer__birthday--input'); 
  
  newBirthdayButton?.addEventListener("click", () => {
    newBirthdayForm.setAttribute("data-active", "true");
    newBirthdayButton.hidden = true;
  });
  
  newBirthdayForm?.addEventListener("submit", async (e) => {
    e.preventDefault();
    const currentBirthdays = document.querySelectorAll("[data-birthday]");
    const nameInput = newBirthdayForm.querySelector("#new_birthday_name");
    const dateInput = newBirthdayForm.querySelector("#new_birthday_date");
    if (nameInput.value === "" || dateInput.value === "") return;
  
    const birthdayDateObject = new Date(dateInput.value)
    const currentDate = new Date();
  
    if (birthdayDateObject > currentDate) {
      alert(window.theme.strings.birthday_future_select_error)
      return
    }
  
    newBirthdayForm.setAttribute("data-active", "false");
    const dateUnix = Math.floor(birthdayDateObject.getTime() / 1000);
  
    const newBirthday = {
      customer: window.customer.id,
      email: window.customer.email,
      properties: {
        field: currentBirthdays.length + 1,
        name: nameInput.value,
        date: dateUnix,
        current_tag: null
      },
    };
  
    await fetch(
      `https://konges-sloejd-middleman.vercel.app/api/update-property-fields/${theme.customer_club.store}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(newBirthday),
      }
    )
      .then((response) => {
        if (response.status === 200) return response.json();
        throw new Error("Something went wrong with the request");
      })
      .then((data) => {
        const html = `
        <li class="customer__birthday--item" data-birthday>
          <h6 class="customer__address--title">${nameInput.value}</h6>
          <input 
            type="date"
            class="customer__birthday--input"
            value="${dateInput.value}"
            max="${theme.customer_club.date}"
          >
          <script birthday-data type="application/json">
            {
              "field": ${currentBirthdays.length + 1},
              "name": "${nameInput.value}",
              "date": "${dateUnix}",
              "current_tag": "${data.current_tag}"
            }
          </script>
        </li>
      `;
        currentBirthdayList.insertAdjacentHTML("beforeend", html);
        nameInput.value = "";
        dateInput.value = "";
        if (currentBirthdays.length < 5) {
            addBirthdayCloseHeader.classList.toggle('d-none');
            addBirthdayToggle.classList.toggle('d-none');
            addBirthdayForm.classList.toggle('d-none');
        } else {
            addBirthdayCloseHeader.classList.add('d-none');
            addBirthdayToggle.classList.add('d-none');
            addBirthdayForm.classList.add('d-none');
        }
      })
      .then(() => {
        existingBirthdayInputs = currentBirthdayList?.querySelectorAll('.customer__birthday--input');
        const newBirthdayInput = existingBirthdayInputs[existingBirthdayInputs?.length - 1];
        if (newBirthdayInput) makeBirthdayInputEditable(newBirthdayInput);
      })
      .catch((error) => console.error(error));
  });

existingBirthdayInputs?.forEach(birthdayInput => {
  makeBirthdayInputEditable(birthdayInput);
});

function makeBirthdayInputEditable(birthdayInput) {
  birthdayInput.addEventListener('blur', async (e) => {
    const inputScriptTag = birthdayInput.nextElementSibling;
    let inputData;
    const birthdayDateObject = new Date(birthdayInput.value);
    const birthdayYear = birthdayDateObject.getFullYear();
    const currentDate = new Date();

    if (birthdayInput.value === "" || birthdayYear < 1900) return;

    const dateUnix = Math.floor(birthdayDateObject.getTime() / 1000);

    if (inputScriptTag?.tagName === "SCRIPT") {
      const json = inputScriptTag?.innerText;
      inputData = JSON.parse(json);
    }

    if (!inputData || Number(inputData.date) == dateUnix) return;
  
    if (birthdayDateObject > currentDate) {
      alert(window.theme.strings.birthday_future_select_error);
      return;
    }

    const editedBirthday = {
      customer: window.customer.id,
      email: window.customer.email,
      properties: {
        field: inputData.field,
        name: inputData.name,
        date: dateUnix,
        current_tag: inputData.current_tag
      },
    };

    await fetch(
      `https://konges-sloejd-middleman.vercel.app/api/update-property-fields/${theme.customer_club.store}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(editedBirthday),
      }
    )
    .then((response) => {
      if (response.status === 200) {
        alert(window.theme.strings.birthday_saved);
        return response.json();
      }
      throw new Error("Something went wrong with the request");
    })
  });
}